import _ from "lodash"
import {generateFetchFieldListAction} from "../../../../apps/KpModule/actions/api"

export const entity = {
    name: "Preparation",
    fields: [
        {path: "auditNumber", unique: true},
        {path: "auditor", type: "User"},
        {path: "auditedOrganizations", type: "Organization", link: "MTM"},
        {path: "auditScope", type: "Axis", link: "MTM"},
        {path: "selectedControls", type: "Control", link: "MTM"},
        {path: "objective"},
        {path: "attentionPoint"},
    ]
}

export const module_ = {
    object: "Preparation",
    tKey: "mTitle_preparation",
    category: {
        path: "audit",
        icon: "bookCheck"
    },
    defaultSortBy: "auditNumber",
    defaultSortDirection: "ASC",
    viewMap: {
        dt: [
            "auditNumber",
            {path: "auditor", display: "completeInfo"},
            {
                path: "auditedOrganizations",
                display: "fullName"
            },
            {
                path: "auditScope",
                display: "fullName"
            }
        ],
        form: [
            {
                path: "auditNumber",
                required: true,
                widthClassName: "col-xs-12 col-sm-6"
            },
            {
                path: "auditor",
                display: "completeInfo",
                required: true,
                widthClassName: "col-xs-12 col-sm-6",
                filters: ["isActive", "isInGroupModel"]
            },
            {
                path: "auditedOrganizations",
                display: "fullName",
                fieldPath: ["id", "organizationAxis", "fullName"],
                filters: ["excludeSelectedOrganizationAxes"],
                subscriptions: {
                    onChange: (newValue, oldValue, {store}) => {
                        store.dispatch(
                            generateFetchFieldListAction(
                                "m-AU-preparation.Preparation_auditedOrganizations",
                                store.getState,
                                {data: {auditedOrganizations: newValue || []}}
                            )
                        )
                    }
                },
                validations: [
                    function(formValues) {
                        return function validation(value, values) {
                            const currentTypes = (value || []).map(type => type.organizationAxis.code)
                            const hasDuplicates = _.uniq(currentTypes).length !== currentTypes.length
                            return hasDuplicates ? 'oneValuePerAxeError' : undefined
                        }
                    }
                ]
            },
            {
                path: "auditScope",
                display: "fullName",
                fieldPath: ["id", "axisType", "fullName"],
                filters: ["excludeSelectedTypes"],
                subscriptions: {
                    onChange: (newValue, oldValue, {store}) => {
                        store.dispatch(
                            generateFetchFieldListAction(
                                "m-AU-preparation.Preparation_auditScope",
                                store.getState,
                                {data: {axesTypes: newValue || []}}
                            )
                        )
                        store.dispatch(
                            generateFetchFieldListAction(
                                "m-AU-preparation.Preparation_selectedControls",
                                store.getState,
                                {data: {auditScopeIds: (newValue || []).map(axis => axis.id)}}
                            )
                        )
                    }
                },
                validations: [
                    function(formValues) {
                        return function validation(value, values) {
                            const currentTypes = (value || []).map(type => type.axisType.code)
                            const hasDuplicates = _.uniq(currentTypes).length !== currentTypes.length
                            return hasDuplicates ? 'oneValuePerTypeError' : undefined
                        }
                    }
                ]
            },
            {
                path: "selectedControls",
                displayMode: 'vertical',
                type: "dualTableList",
                leftBoxTKey: "availableControls",
                display: "name",
                fieldPath: [
                    "id", "translatedName",
                    "risk.id", "risk.translatedName",
                    "risk.riskType.id", "risk.riskType.translatedName",
                    "controlType.id", "controlType.translatedName",
                    "maturityControl.id", "maturityControl.translatedName"
                ],
                columns: [
                    {path: "risk.riskType.translatedName", tKey: "riskType"},
                    {path: "risk.translatedName", tKey: "risk"},
                    {path: "controlType.translatedName", tKey: "controlType"},
                    {path: "maturityControl.translatedName", tKey: "maturityControl"},
                    {path: "translatedName", tKey: "control"}
                ],
                filters: ["byAuditScope"]
            },
            {path: "objective", type: "richTextEditor"},
            {path: "attentionPoint", type: "richTextEditor"},
        ]
    }
}